/**
 * Burnout Test Page
 * Route Component für den Burnout Test
 */

import BurnoutTestComponent from '../components/BurnoutTestComponent';

export function BurnoutTestPage() {
  return <BurnoutTestComponent />;
}








